export type BulkAction = "activate" | "deactivate" | "delete";

/** Bulk action bar (US-F2) — appears when ≥1 ad is selected. */
export function BulkBar({
  count,
  busy,
  onAction,
}: {
  count: number;
  busy?: boolean;
  onAction: (action: BulkAction) => void;
}) {
  return (
    <div className="bulkbar" role="region" aria-label="Bulk actions">
      <span className="bulkbar-count">{count} selected</span>
      <button type="button" className="btn" disabled={busy} onClick={() => onAction("activate")}>
        Activate
      </button>
      <button type="button" className="btn" disabled={busy} onClick={() => onAction("deactivate")}>
        Deactivate
      </button>
      <button type="button" className="btn danger" disabled={busy} onClick={() => onAction("delete")}>
        Delete
      </button>
    </div>
  );
}
